import React from "react";

/**
 * Brand image assets — actual One Sphere logo files (transparent PNG).
 * Stored in /public so they're served from the root.
 */
const FULL_LOGO = "/one-sphere-logo.png";       // sphere + wordmark stacked
const MARK = "/one-sphere-mark.png";            // sphere only
const WORDMARK_IMG = "/one-sphere-wordmark.png"; // wordmark only

/** Sphere mark only (no text). */
export const DotSphere = ({ size = 48, className = "", alt = "One Sphere" }) => (
  <img
    src={MARK}
    width={size}
    height={size}
    alt={alt}
    className={className}
    style={{ width: typeof size === "number" ? `${size}px` : size, height: "auto", display: "block" }}
    draggable={false}
  />
);

/** Wordmark only (the "ONE SPHERE" text image). */
export const Wordmark = ({ height = 18, className = "" }) => (
  <img
    src={WORDMARK_IMG}
    alt="One Sphere"
    height={height}
    className={className}
    style={{ height: `${height}px`, width: "auto", display: "block" }}
    draggable={false}
  />
);

/** Inverted/light wordmark — uses CSS to invert the dark logo for dark backgrounds. */
export const WordmarkOnDark = ({ height = 18, className = "" }) => (
  <img
    src={WORDMARK_IMG}
    alt="One Sphere"
    height={height}
    className={className}
    style={{
      height: `${height}px`,
      width: "auto",
      display: "block",
      filter: "brightness(0) invert(1)",
    }}
    draggable={false}
  />
);

/** Horizontal lockup: sphere + wordmark side-by-side. */
export const LogoLockup = ({
  height = 32,
  className = "",
  variant = "light",
}) => (
  <div className={`inline-flex items-center gap-2.5 ${className}`}>
    <img
      src={MARK}
      alt=""
      style={{
        height: `${height}px`,
        width: "auto",
        display: "block",
        filter: variant === "dark" ? "brightness(0) invert(1)" : "none",
      }}
      draggable={false}
    />
    {variant === "dark" ? (
      <WordmarkOnDark height={Math.round(height * 0.45)} />
    ) : (
      <Wordmark height={Math.round(height * 0.45)} />
    )}
  </div>
);

/** Full stacked logo (sphere on top, wordmark below) — for hero / large displays. */
export const FullLogo = ({ width = 480, className = "", variant = "light" }) => (
  <img
    src={FULL_LOGO}
    alt="One Sphere — General Trading"
    className={className}
    style={{
      width: typeof width === "number" ? `${width}px` : width,
      height: "auto",
      display: "block",
      filter: variant === "dark" ? "brightness(0) invert(1)" : "none",
    }}
    draggable={false}
  />
);

export default DotSphere;
